
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1B2xl", function(module, exports) {

$parcel$export(module.exports, "getRandomUniqueNumbers", () => $ecc34a56e3ca8c79$export$cbb224b90d3f0722);
function $ecc34a56e3ca8c79$export$cbb224b90d3f0722(count, min, max) {
    const numbers = [];
    while(numbers.length < count){
        const num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (!numbers.includes(num)) numbers.push(num);
    }
    return numbers;
}

});

parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("dWkAg", function(module, exports) {

$parcel$export(module.exports, "areCoordsEqual", () => $526be0ad93c3e4bf$export$102b20725d4d2263);
function $526be0ad93c3e4bf$export$102b20725d4d2263(coordArr1, coordArr2) {
    if (coordArr1.length !== coordArr2.length) return false;
    return coordArr1.every((point, index)=>{
        const other = coordArr2[index];
        return point.x === other.x && point.y === other.y;
    });
}

});

parcelRegister("jZEcn", function(module, exports) {

$parcel$export(module.exports, "generateAngles", () => $83c21d34517267ce$export$adec80d12bc0398e);

var $a92Ax = parcelRequire("a92Ax");

var $cwj7p = parcelRequire("cwj7p");
function $83c21d34517267ce$export$adec80d12bc0398e(p, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
    const degree = (0, $cwj7p.default)({
        startRadian: startRadian,
        endRadian: endRadian
    }, clockwise, false);
    return {
        startRadian: startRadian,
        endRadian: endRadian,
        degree: degree
    };
}

});
parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});

parcelRegister("cwj7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6eb8af25d6ad3b0$export$2e2bcd8739ae039);

var $74Gga = parcelRequire("74Gga");
function $a6eb8af25d6ad3b0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $74Gga.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("74Gga", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b402dd6b18638d$export$2e2bcd8739ae039);
function $e6b402dd6b18638d$export$2e2bcd8739ae039(radian) {
    return Math.round(radian * (180 / Math.PI));
}

});



parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("gix9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4713a546dfab5e00$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $krubk = parcelRequire("krubk");

var $erVR3 = parcelRequire("erVR3");
class $4713a546dfab5e00$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    Switcher;
    Header;
    coords;
    handleFunc;
    constructor({ header: header, coords: coords, handleFunc: handleFunc }){
        super();
        this.coords = coords;
        this.handleFunc = handleFunc;
        this.addHeader(header);
        this.addCoord();
        this.addSwitcher();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (v)=>this.visible = v;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        let coord = this.coords.horizontal;
        if (dim.WIDTH < dim.HEIGHT) coord = {
            x: dim.WIDTH / 2 + this.coords.vertical.x,
            y: dim.HEIGHT / 2 + this.coords.vertical.y
        };
        Object.assign(this, coord);
    }
    addHeader(header) {
        this.Header = new $iuB9z.Text({
            text: header
        });
        this.Header.anchor.set(.5);
        this.Header.x = 0;
        this.Header.y = -32;
        this.addChild(this.Header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $krubk.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.Switcher.x = 0;
        this.Switcher.y = 0;
        this.addChild(this.Switcher);
    }
    getActivationStatus = ()=>this.Switcher.getActive();
    setActivation(v) {
        const isActive = this.Switcher.getActive();
        if (v && isActive) this.Switcher.handleSwitcher(!isActive);
    }
}

});
parcelRegister("krubk", function(module, exports) {

$parcel$export(module.exports, "default", () => $621ca3294779f8aa$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $8xLbP = parcelRequire("8xLbP");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $621ca3294779f8aa$var$BUTTON_X = 10;
class $621ca3294779f8aa$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    isActive = false;
    greenBg;
    grayBg;
    button;
    handleSwitch;
    constructor(color, handleSwitch, isAddCon = false){
        super();
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).closeSwitcher, ()=>this.handleSwitcherOff());
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    getActive = ()=>this.isActive;
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $iuB9z.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitcher(isActive) {
        this.isActive = isActive;
        this.handleSwitch(this.isActive);
        new (0, $8xLbP.default)(this);
    }
    handleSwitcherOff() {
        if (!this.isActive) return;
        this.handleSwitcher(false);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.handleSwitcher(!this.isActive);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $621ca3294779f8aa$var$BUTTON_X * v : 2 * $621ca3294779f8aa$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $iuB9z.Graphics().circle(-$621ca3294779f8aa$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("8xLbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $074e271eb87a9bab$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $074e271eb87a9bab$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $6m47o.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});



parcelRegister("jtirH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c5a2df4ae2bc79$export$2e2bcd8739ae039);
function $34c5a2df4ae2bc79$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");
var $1062f3efb6649654$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumEventBus["setSltdTPIndex"] = "SET_SELECTED_TANGENT_POINT_INDEX";
    EnumEventBus["genRndmTriangle"] = "GENERATE_RANDOM_TRIANGLE";
    EnumEventBus["quasimodoMode"] = "QUASIMODO_MODE";
    EnumEventBus["moveTangentPoint"] = "MOVE_TANGENT_POINT";
    EnumEventBus["moveAllPoints"] = "MOVE_ALL_POINTS";
    EnumEventBus["setRefPoints"] = "SET_REF_POINTS";
    return EnumEventBus;
}({});
const $1062f3efb6649654$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



const $e0f5db51c36ebaf4$export$c7609d9da8d80867 = {
    x: 600,
    y: 390
};
const $e0f5db51c36ebaf4$export$2bf7a7762037fddc = [
    Math.PI / 2,
    Math.PI * 9 / 8,
    -Math.PI / 8
];
const $e0f5db51c36ebaf4$export$ca8f2c484d507a5d = 200;
const $e0f5db51c36ebaf4$export$158208f930a33a87 = {
    x: 100,
    y: 20
};
const $e0f5db51c36ebaf4$export$e7d0c45026efed5d = {
    x: 100,
    y: 60
};
const $e0f5db51c36ebaf4$export$1312ecbb29a79419 = {
    x: 250,
    y: 800
};
const $e0f5db51c36ebaf4$export$186dbbe504e85fe1 = [
    {
        x: 450,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $e0f5db51c36ebaf4$export$75f2cc8245aafe09 = [
    {
        x: 60,
        y: 420
    },
    {
        x: 60,
        y: 600
    }
];
const $e0f5db51c36ebaf4$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $e0f5db51c36ebaf4$export$190b4c043fb6edf4 = {
    x: 1500,
    y: 800
};
const $e0f5db51c36ebaf4$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $e0f5db51c36ebaf4$export$301500ed3a742f63 = [
    0x21D4FE,
    0x0195B8
];
const $e0f5db51c36ebaf4$export$321ead0620a8fedc = [
    0xb06efe,
    0xb06efe
];
const $e0f5db51c36ebaf4$export$9c42f2d310db4e52 = [
    $e0f5db51c36ebaf4$export$301500ed3a742f63[1],
    $e0f5db51c36ebaf4$export$7a003cdef7722780[1],
    0x000000
];
const $e0f5db51c36ebaf4$export$c6fbe3a520aa2995 = {
    x: 120,
    y: 250
};
const $e0f5db51c36ebaf4$export$2e51dc0dfab2d766 = "circle-theorem-3";
const $e0f5db51c36ebaf4$export$80701b8f8598becf = [
    "/circle-theorem-3/quasimodo/head.png",
    "/circle-theorem-3/quasimodo/foot.png",
    "/circle-theorem-3/quasimodo/corkscrew.png"
];



var $darcK = parcelRequire("darcK");
function $631e5a93655f9438$export$72dbddf526f8a6f(cPoint, cirPoint, lenght) {
    const r = Math.atan2(cirPoint.y - cPoint.y, cirPoint.x - cPoint.x);
    const t = (0, $darcK.normalizeRadian)(r + Math.PI / 2);
    const generatePoint = (l)=>({
            x: cirPoint.x + Math.cos(t) * l,
            y: cirPoint.y + Math.sin(t) * l
        });
    return [
        generatePoint(-lenght / 2),
        generatePoint(lenght / 2)
    ];
}



var $1B2xl = parcelRequire("1B2xl");

var $iD90R = parcelRequire("iD90R");
async function $17b7268d021d3b24$export$4777bb8a9f19b87(PointManager) {
    const radians = PointManager.getRadians();
    const RedPoints = PointManager.getRedPoints();
    const newRadians = (0, $1B2xl.getRandomUniqueNumbers)(3, 0, 5).sort((a, b)=>a - b);
    newRadians.map((v)=>v * (Math.PI / 3)).sort().reverse();
    await (0, $iD90R.moveAllPointAnim)(radians, newRadians, (radian, index)=>PointManager.setRadian([
            {
                pTag: RedPoints[index].tag,
                radian: radian
            }
        ]));
}



var $5ehzb = parcelRequire("5ehzb");
class $0b50a0d0eae351ce$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    tangent = [];
    sltdTPIndex = 0 // selected Tangent Point Index
    ;
    constructor(cCoord){
        super(cCoord, (0, $e0f5db51c36ebaf4$export$ca8f2c484d507a5d), (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc));
        this.setCoord();
        this.draw();
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).genRndmTriangle, ()=>this.generateRandomShape());
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).moveTangentPoint, (v)=>this.moveTangentPoint(v));
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).moveAllPoints, (v)=>this.moveAllPoints(v));
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).setRefPoints, ()=>this.pointRefRadians = [
                ...this.pointRadians
            ]);
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).setSltdTPIndex, (index)=>{
            this.sltdTPIndex = index;
            this.setCoord();
        });
    }
    setTangentCoords = ()=>{
        const tPointCoord = this.getRedPointsCoord()[this.sltdTPIndex];
        return (0, $631e5a93655f9438$export$72dbddf526f8a6f)(this.cCoord, tPointCoord, 300);
    };
    getTangentCoords = ()=>this.setTangentCoords();
    getSltdTPointIndex = ()=>this.sltdTPIndex;
    generateRandomShape = ()=>(0, $17b7268d021d3b24$export$4777bb8a9f19b87)(this);
    moveTangentPoint(v) {
        const tangentPoint = this.getRedPoints()[this.sltdTPIndex];
        const radian = this.pointRefRadians[this.sltdTPIndex] + v / 100 * (Math.PI / 3);
        this.setRadian([
            {
                pTag: tangentPoint.tag,
                radian: radian
            }
        ], true);
    }
    moveAllPoints(v) {
        const pointInfoArr = [
            ...this.getRedPoints()
        ].map((p, pI)=>{
            const radian = this.pointRefRadians[pI] + v / 100 * (Math.PI / 3);
            return {
                pTag: p.tag,
                radian: radian
            };
        });
        this.setRadian(pointInfoArr, true);
    }
    setCoord() {
        this.setTangentCoords();
        this._setCoord();
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");

class $10871b41c2a4aae5$export$2e2bcd8739ae039 {
    triangle = [
        new (0, $d0yDD.default)(),
        new (0, $d0yDD.default)(),
        new (0, $d0yDD.default)()
    ];
    tangent = new (0, $d0yDD.default)({
        color: (0, $e0f5db51c36ebaf4$export$321ead0620a8fedc)[0]
    });
    colors;
    ishownSecondSegment = true;
    showPink = true;
    constructor(colors){
        this.colors = colors;
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>{
            this.clearAll();
            this.showPink = true;
        });
    }
    setQuasimodo(status) {
        this.showPink = !status;
    }
    setAllVisible = (status)=>[
            this.tangent,
            ...this.triangle
        ].forEach((l)=>l.visible = status);
    setIsShowSecondSegment = (status)=>this.ishownSecondSegment = status;
    clearAll() {
        this.triangle.forEach((l)=>{
            l.setLineColor(0x000000);
            l.clear();
        });
        this.tangent.clear();
    }
    draw(points, tPoints, sltdTPIndex) {
        const sI = sltdTPIndex;
        const prevI = sI != 0 ? sI - 1 : points.length - 1;
        this.triangle.forEach((line, lI)=>{
            line.setLineColor(lI == sI ? this.showPink ? this.colors[1] : 0x000000 : lI == prevI && this.ishownSecondSegment ? this.colors[0] : 0x000000);
            line.draw(points[lI], points[points.length == lI + 1 ? 0 : lI + 1]);
        });
        this.tangent.draw(tPoints[0], tPoints[1]);
    }
}



var $9ec1t = parcelRequire("9ec1t");

var $g4gW0 = parcelRequire("g4gW0");


var $eP48i = parcelRequire("eP48i");
function $fee6af0fc890fa20$export$73935091fa556468(angle, aPms, clockwise) {
    const smllDistance = Math.min((0, $eP48i.default)(aPms.points.curr, aPms.points.prev), (0, $eP48i.default)(aPms.points.curr, aPms.points.next));
    angle.smallDistance = Math.floor(smllDistance);
    angle.draw(aPms.points.curr, aPms.startRadian, aPms.endRadian, aPms.degree, clockwise);
    angle.x = aPms.points.curr.x;
    angle.y = aPms.points.curr.y;
    angle.rotation = 0;
}


function $bf5d1d8485177fe9$export$5f61282e9abe72d5(points) {
    return [
        {
            curr: points[0],
            prev: points[2],
            next: points[1]
        },
        {
            curr: points[1],
            prev: points[0],
            next: points[2]
        },
        {
            curr: points[2],
            prev: points[1],
            next: points[0]
        }
    ];
}



var $dWkAg = parcelRequire("dWkAg");

var $jZEcn = parcelRequire("jZEcn");

var $erVR3 = parcelRequire("erVR3");
class $f3966b3c6cf05d40$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    circumAnglePink = new (0, $g4gW0.default)("circumPink", {
        color: (0, $e0f5db51c36ebaf4$export$7a003cdef7722780)[0],
        textColor: (0, $e0f5db51c36ebaf4$export$7a003cdef7722780)[1]
    });
    circumAngleBlue = new (0, $g4gW0.default)("circumBlue", {
        color: (0, $e0f5db51c36ebaf4$export$301500ed3a742f63)[0],
        textColor: (0, $e0f5db51c36ebaf4$export$301500ed3a742f63)[1]
    });
    alternativeAnglePink = new (0, $g4gW0.default)("alternativePink", {
        color: (0, $e0f5db51c36ebaf4$export$7a003cdef7722780)[0],
        textColor: (0, $e0f5db51c36ebaf4$export$7a003cdef7722780)[1]
    }, 10, true);
    alternativeAngleBlue = new (0, $g4gW0.default)("alternativeBlue", {
        color: (0, $e0f5db51c36ebaf4$export$301500ed3a742f63)[0],
        textColor: (0, $e0f5db51c36ebaf4$export$301500ed3a742f63)[1]
    }, 10, true);
    isShownSecondSegment = true;
    currPoints = [];
    currDegrees = [];
    constructor(){
        this.Layers.Top.addChild(this.alternativeAnglePink);
        this.Layers.Top.addChild(this.alternativeAngleBlue);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    setVisibles(status) {
        this.setAllVisible(status);
        this.setIsShownSecondSegment(false);
    }
    setAllVisible(status) {
        [
            this.circumAnglePink,
            this.alternativeAnglePink,
            this.circumAngleBlue,
            this.alternativeAngleBlue
        ].forEach((angle)=>angle.setVisible(status));
    }
    setIsShownSecondSegment(v) {
        this.isShownSecondSegment = !v;
        [
            this.circumAnglePink,
            this.alternativeAnglePink
        ].forEach((angle)=>{
            angle.visible = !v;
            angle.AngleValue.visible = !v;
        });
    }
    draw(points, tangentCoords, sltdTPIndex, clockwise) {
        const sI = sltdTPIndex;
        const pL = points.length;
        const bI = sI != pL - 1 ? sI + 1 : 0;
        const pI = sI != 0 ? sI - 1 : pL - 1;
        const angleParams = this.generateAngleParams(points.map((p)=>({
                x: p.x,
                y: p.y
            })), sI, clockwise);
        const blueP = {
            curr: points[sI],
            prev: tangentCoords[clockwise ? 0 : 1],
            next: points[pI]
        };
        const blueDetail = (0, $jZEcn.generateAngles)(blueP, !clockwise);
        const alternatifParamsB = {
            startRadian: blueDetail.startRadian,
            endRadian: blueDetail.endRadian,
            degree: angleParams[bI].degree,
            points: blueP
        };
        (0, $fee6af0fc890fa20$export$73935091fa556468)(this.circumAngleBlue, angleParams[bI], clockwise);
        (0, $fee6af0fc890fa20$export$73935091fa556468)(this.alternativeAngleBlue, alternatifParamsB, clockwise);
        if (this.isShownSecondSegment) {
            const pinkP = !clockwise ? {
                curr: points[sI],
                prev: tangentCoords[0],
                next: points[bI]
            } : {
                curr: points[sI],
                prev: points[bI],
                next: tangentCoords[1]
            };
            const pinkDetail = (0, $jZEcn.generateAngles)(pinkP, clockwise);
            const alternatifParams = {
                startRadian: pinkDetail.startRadian,
                endRadian: pinkDetail.endRadian,
                degree: angleParams[pI].degree,
                points: pinkP
            };
            (0, $fee6af0fc890fa20$export$73935091fa556468)(this.circumAnglePink, angleParams[pI], clockwise);
            (0, $fee6af0fc890fa20$export$73935091fa556468)(this.alternativeAnglePink, alternatifParams, true);
        }
    }
    generateAngleParams(points, sI, clockwise) {
        const anglePoints = (0, $bf5d1d8485177fe9$export$5f61282e9abe72d5)(points);
        const params = anglePoints.map((obj)=>{
            const angles = (0, $jZEcn.generateAngles)(obj, clockwise);
            return {
                points: obj,
                startRadian: angles.startRadian,
                endRadian: angles.endRadian,
                degree: angles.degree
            };
        });
        if (!(0, $dWkAg.areCoordsEqual)(this.currPoints, points)) {
            this.currPoints = points;
            const otherIndex = [
                0,
                1,
                2
            ].filter((i)=>i != sI);
            const twoDegree = params[otherIndex[0]].degree + params[otherIndex[1]].degree;
            params[sI].degree = 180 - twoDegree;
            this.currDegrees = params.map((p)=>p.degree);
        } else params.forEach((param, pI)=>param.degree = this.currDegrees[pI]);
        return params;
    }
}



var $9m5D8 = parcelRequire("9m5D8");
class $b2d727539ee7a1b6$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C"
        ]);
    }
}



var $b2sIL = parcelRequire("b2sIL");


const $1eea3e1688a0cc7c$var$SliderGen = [
    {
        head: "move tangent point",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v)=>(0, $1062f3efb6649654$export$f6644f0f2c90144b).emit((0, $1062f3efb6649654$export$cb883390c27ec6dd).moveTangentPoint, v - 100)
    },
    {
        head: "rotate triangle",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $1062f3efb6649654$export$f6644f0f2c90144b).emit((0, $1062f3efb6649654$export$cb883390c27ec6dd).moveAllPoints, v - 100)
    }
];
class $1eea3e1688a0cc7c$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    constructor(){
        super($1eea3e1688a0cc7c$var$SliderGen, (0, $e0f5db51c36ebaf4$export$186dbbe504e85fe1), (0, $e0f5db51c36ebaf4$export$75f2cc8245aafe09));
    }
}



var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");



var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $56898590c7d85123$export$2e2bcd8739ae039 extends $iuB9z.Graphics {
    Layers = (0, $9ec1t.default).getInstance();
    index;
    fillColor = (0, $e0f5db51c36ebaf4$export$321ead0620a8fedc)[0];
    strokeColor = (0, $e0f5db51c36ebaf4$export$321ead0620a8fedc)[1];
    constructor(index){
        super();
        this.index = index;
        this.addInteractivity();
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addInteractivity() {
        const setSltdTPIndex = ()=>(0, $1062f3efb6649654$export$f6644f0f2c90144b).emit((0, $1062f3efb6649654$export$cb883390c27ec6dd).setSltdTPIndex, this.index);
        (0, $16Wgx.default)(this, {
            handleDownFunc: setSltdTPIndex
        }, (0, $16HUD.CustomCursorType).target);
    }
    draw(coord, selected) {
        const r = 14;
        const strokeW = 3;
        this.clear().circle(coord.x, coord.y, r + (selected ? strokeW / 2 : 0));
        selected ? this.fill(this.fillColor) : this.fill(0xFFFFFF).stroke({
            color: this.strokeColor,
            width: strokeW
        });
    }
}


class $8779ca3a487f6ed7$export$2e2bcd8739ae039 {
    triangle = Array(3).fill(null).map((_, index)=>new (0, $56898590c7d85123$export$2e2bcd8739ae039)(index));
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    setAllVisible = (status)=>this.triangle.forEach((b)=>b.visible = status);
    draw(coords, sltdTPIndex) {
        this.triangle.forEach((button, bI)=>button.draw(coords[bI], bI == sltdTPIndex));
    }
}



var $erVR3 = parcelRequire("erVR3");


var $iD90R = parcelRequire("iD90R");

async function $b6aaa5933e967309$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, PointManager: PointManager, LineManager: LineManager, AngleManager: AngleManager, cCoord: cCoord } = context;
    const sltdTPIndex = PointManager.getSltdTPointIndex();
    const PointsCoord = PointManager.getRedPointsCoord();
    const TPointsCoord = PointManager.getTangentCoords();
    const circlePoint = PointManager.getPoints()[0];
    const RedPoints = PointManager.getRedPoints();
    circle.draw({
        radius: circle.radius,
        radians: Array(3).fill((0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[0] - 2 * Math.PI)
    });
    await (0, $iD90R.drawPointsAnim)([
        circlePoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[0], 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.triangle[0], PointsCoord[0], PointsCoord[1]);
    await (0, $iD90R.drawLineAnim)(LineManager.triangle[1], PointsCoord[1], PointsCoord[2]);
    await (0, $iD90R.drawLineAnim)(LineManager.triangle[2], PointsCoord[2], PointsCoord[0]);
    await (0, $iD90R.drawLineAnim)(LineManager.tangent, TPointsCoord[0], TPointsCoord[1]);
    circle.radians = Array(3).fill((0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[0]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1], 2, false, cCoord);
    LineManager.setIsShowSecondSegment(false);
    LineManager.draw(PointsCoord, TPointsCoord, sltdTPIndex);
    (0, $iD90R.drawAngleAnim)(AngleManager.circumAnglePink, "p");
    await (0, $iD90R.drawAngleAnim)(AngleManager.alternativeAnglePink, "p");
    circle.setColors([
        (0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52)[2],
        (0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52)[1],
        (0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52)[2]
    ]);
    await (0, $iD90R.movePointAnim)((0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[2], (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[2] + Math.PI / 8, (radian)=>PointManager.setRadian([
            {
                pTag: RedPoints[2].tag,
                radian: radian
            }
        ]));
    await (0, $iD90R.movePointAnim)((0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[2] + Math.PI / 8, (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[2], (radian)=>PointManager.setRadian([
            {
                pTag: RedPoints[2].tag,
                radian: radian
            }
        ]));
    circle.radians = [
        (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[0],
        (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[0],
        (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1]
    ];
    circle.setColors((0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52));
    await (0, $iD90R.drawCircleAnim)(circle, Math.PI - (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1], 0, false, cCoord);
    LineManager.setIsShowSecondSegment(true);
    LineManager.draw(PointsCoord, TPointsCoord, sltdTPIndex);
    (0, $iD90R.drawAngleAnim)(AngleManager.circumAngleBlue, "b");
    await (0, $iD90R.drawAngleAnim)(AngleManager.alternativeAngleBlue, "b");
    await (0, $iD90R.movePointAnim)((0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1], (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1] + Math.PI / 8, (radian)=>PointManager.setRadian([
            {
                pTag: RedPoints[1].tag,
                radian: radian
            }
        ]));
    await (0, $iD90R.movePointAnim)((0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1] + Math.PI / 8, (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc)[1], (radian)=>PointManager.setRadian([
            {
                pTag: RedPoints[1].tag,
                radian: radian
            }
        ]));
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

class $5cdef9b8986da9da$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    LineManager;
    circle;
    cCoord;
    isSwitcherActive;
    constructor(PointManager, AngleManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.isSwitcherActive = false;
        this.getDelayForStartAnim = ()=>this.isSwitcherActive ? 1000 : 0;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $e0f5db51c36ebaf4$export$840ec2322406bfdd), ()=>this.runAnimations(), ()=>this.getDelayForStartAnim());
        this.AngleManager.draw(PointManager.getRedPoints(), PointManager.getTangentCoords(), 0, true);
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).quasimodoMode, (v)=>this.isSwitcherActive = v);
        this.addCircAnimBut();
    }
    getDelayForStartAnim;
    addCircAnimBut;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            PointManager: this.PointManager,
            AngleManager: this.AngleManager,
            LineManager: this.LineManager,
            circle: this.circle,
            cCoord: this.cCoord
        };
        (0, $b6aaa5933e967309$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}



var $iiVV4 = parcelRequire("iiVV4");

var $fGH3X = parcelRequire("fGH3X");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");


var $hCdov = parcelRequire("hCdov");

var $2h5MD = parcelRequire("2h5MD");

var $kSVlj = parcelRequire("kSVlj");

var $iuB9z = parcelRequire("iuB9z");

var $7vBln = parcelRequire("7vBln");
function $db5ad71271d13f91$export$2e2bcd8739ae039(path, bounds, anchor) {
    const texture = (0, $7vBln.default).getTexture(path);
    const sprite = new $iuB9z.Sprite(texture);
    sprite.x = -1000;
    sprite.y = -1000;
    Object.assign(sprite, bounds);
    sprite.scaleValue = bounds.scale;
    sprite.anchor.set(anchor.x, anchor.y);
    return sprite;
}


function $6f7defc88dd4ea64$export$2e2bcd8739ae039(point1, point2) {
    return Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
}


const $e6beafb024a9362f$var$_scale = 112 / 604;
class $e6beafb024a9362f$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    head;
    foot;
    corkscrew;
    pant;
    constructor(coord){
        super();
        Object.assign(this, coord);
        this.add();
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    setVisible(status) {
        const onUpdate = (e, v)=>e.scale.set(v, Math.abs(v));
        [
            this.head,
            this.corkscrew,
            ...this.foot
        ].forEach((QmdPart)=>{
            const scale = QmdPart.scaleValue;
            if (status) {
                QmdPart.visible = true;
                onUpdate(QmdPart, scale * .5);
                new (0, $kSVlj.default)(scale * .5, scale, (v)=>onUpdate(QmdPart, v));
            } else new (0, $kSVlj.default)(scale, scale * .5, (v)=>onUpdate(QmdPart, v), ()=>QmdPart.visible = status);
        });
        if (!status) this.pant.clear();
    }
    add() {
        this.addPant();
        this.addHead();
        this.addFoot();
        this.addCorkscrew();
    }
    addHead = ()=>{
        this.head = (0, $db5ad71271d13f91$export$2e2bcd8739ae039)((0, $e0f5db51c36ebaf4$export$80701b8f8598becf)[0], {
            width: 133,
            height: 138,
            scale: 133 / 489
        }, {
            x: .5,
            y: 1
        });
        this.addChild(this.head);
    };
    addCorkscrew = ()=>{
        this.corkscrew = (0, $db5ad71271d13f91$export$2e2bcd8739ae039)((0, $e0f5db51c36ebaf4$export$80701b8f8598becf)[2], {
            width: 105,
            height: 661,
            scale: .35
        }, {
            x: .5,
            y: 0
        });
        this.Layers.Info.addChild(this.corkscrew);
    };
    addFoot() {
        this.foot = Array(2).fill(null).map((_, fI)=>{
            const scale = 112 / 604 * (fI == 0 ? 1 : -1);
            const feet = (0, $db5ad71271d13f91$export$2e2bcd8739ae039)((0, $e0f5db51c36ebaf4$export$80701b8f8598becf)[1], {
                width: 112,
                height: 77,
                scale: scale
            }, {
                x: .85,
                y: 0
            });
            feet.scale.set(scale, scale);
            this.addChild(feet);
            return feet;
        });
    }
    addPant() {
        this.pant = new $iuB9z.Graphics();
        this.addChild(this.pant);
    }
    drawPant(sltdTPIndex, pIndex, radius, radians, clockwise) {
        const points = (0, $hCdov.default)({
            x: 0,
            y: 0
        }, radians, radius);
        const rs = clockwise ? [
            radians[sltdTPIndex],
            radians[pIndex]
        ] : [
            radians[pIndex],
            radians[sltdTPIndex]
        ];
        this.pant.clear().moveTo(points[sltdTPIndex].x, points[sltdTPIndex].y).lineTo(points[pIndex].x, points[pIndex].y).arc(0, 0, radius, rs[0], rs[1]).fill(0xF4AF74);
    }
    updateCoord(sltdTPIndex, radians, radius, clockwise) {
        const prevIndex = sltdTPIndex != 0 ? sltdTPIndex - 1 : radians.length - 1;
        const nextIndex = sltdTPIndex != radians.length - 1 ? sltdTPIndex + 1 : 0;
        const points = (0, $hCdov.default)({
            x: 0,
            y: 0
        }, radians, radius + 25);
        const corkPoint = {
            x: this.x + Math.cos(radians[sltdTPIndex]) * (radius - 30),
            y: this.y + Math.sin(radians[sltdTPIndex]) * (radius - 30)
        };
        Object.assign(this.foot[0], points[sltdTPIndex]);
        Object.assign(this.foot[1], points[prevIndex]);
        Object.assign(this.head, points[nextIndex]);
        Object.assign(this.corkscrew, corkPoint);
        const footScale = clockwise ? -$e6beafb024a9362f$var$_scale : $e6beafb024a9362f$var$_scale;
        this.foot[0].rotation = radians[sltdTPIndex] - Math.PI / 2;
        this.foot[0].scale.set(footScale, Math.abs(footScale));
        this.foot[1].rotation = radians[prevIndex] - Math.PI / 2;
        this.foot[1].scale.set(-footScale, Math.abs(footScale));
        const corkRadian = (0, $2h5MD.default)(points[nextIndex], points[sltdTPIndex]);
        this.head.rotation = radians[nextIndex] + Math.PI / 2;
        this.corkscrew.rotation = corkRadian + Math.PI / 2;
        const distance = (0, $6f7defc88dd4ea64$export$2e2bcd8739ae039)(points[sltdTPIndex], points[nextIndex]);
        this.corkscrew.scale.set(this.corkscrew.scaleValue, this.corkscrew.scaleValue * (distance < 365 ? distance / 365 : 1));
        this.drawPant(sltdTPIndex, prevIndex, radius, radians, clockwise);
    }
}



var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");


var $llFKB = parcelRequire("llFKB");

const $c558534c0b88c6e9$var$ButtonStyle = {
    width: 280,
    height: 120,
    wordWrapWidth: 160,
    defaultColor: 0xCECECE,
    hoverColor: 0xDEDEDE,
    pressedColor: 0xC5C5C5,
    borderColor: 0x111111,
    titleColor: 0x111111,
    titleFontSize: 28,
    borderRadius: 22
};
class $c558534c0b88c6e9$export$2e2bcd8739ae039 extends (0, $llFKB.default) {
    Game = (0, $75RpY.default).getInstance();
    constructor(){
        super("Generate Random Triangle", $c558534c0b88c6e9$var$ButtonStyle, ()=>this.createRandomTriangle());
        this.addCoord();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    createRandomTriangle = ()=>(0, $1062f3efb6649654$export$f6644f0f2c90144b).emit((0, $1062f3efb6649654$export$cb883390c27ec6dd).genRndmTriangle);
    setVisible = (v)=>this.visible = v;
    addCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) {
            this.x = (0, $e0f5db51c36ebaf4$export$1312ecbb29a79419).x;
            this.y = (0, $e0f5db51c36ebaf4$export$1312ecbb29a79419).y;
            return;
        }
        this.x = dim.WIDTH / 2 - 200;
        this.y = dim.HEIGHT / 2 + 420;
    }
}



var $gix9M = parcelRequire("gix9M");


const $a2464897f5ac9e36$var$header = "Quasimodo Mode:";
const $a2464897f5ac9e36$var$coords = {
    horizontal: (0, $e0f5db51c36ebaf4$export$c6fbe3a520aa2995),
    vertical: {
        x: -200,
        y: 630
    }
};
const $a2464897f5ac9e36$var$handleFunc = (isActive)=>(0, $1062f3efb6649654$export$f6644f0f2c90144b).emit((0, $1062f3efb6649654$export$cb883390c27ec6dd).quasimodoMode, isActive);
class $a2464897f5ac9e36$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: $a2464897f5ac9e36$var$header,
            coords: $a2464897f5ac9e36$var$coords,
            handleFunc: $a2464897f5ac9e36$var$handleFunc
        });
    }
}


function $3ee823957752351b$export$8bcf5a95f698e8c4(radians, isbtw) {
    const r = [
        ...radians
    ];
    return isbtw ? [
        r[2],
        r[1],
        r[0]
    ] : r;
}


function $9557195dc346e5c1$export$e6ec757508d1274(sI, radians, radius, isbtw) {
    const rL = radians.length;
    const endRadian = radians[sI != 0 ? sI - 1 : rL - 1];
    const middleRadian = radians[sI];
    const startRadian = radians[sI != rL - 1 ? sI + 1 : 0];
    const _radians = [
        endRadian,
        middleRadian,
        startRadian
    ];
    const Radians = (0, $3ee823957752351b$export$8bcf5a95f698e8c4)(_radians, isbtw);
    const details = {
        radians: Radians,
        radius: radius
    };
    return details;
}



var $hCdov = parcelRequire("hCdov");

var $jtirH = parcelRequire("jtirH");

var $3DpJv = parcelRequire("3DpJv");

var $c6c6Q = parcelRequire("c6c6Q");

const $4db0316fd3255fae$var$text = "Select the points to swap the tangent";
const $4db0316fd3255fae$var$color = (0, $e0f5db51c36ebaf4$export$321ead0620a8fedc)[0];
class $4db0316fd3255fae$export$2e2bcd8739ae039 extends (0, $c6c6Q.default) {
    constructor(){
        super($4db0316fd3255fae$var$text, $4db0316fd3255fae$var$color, (0, $e0f5db51c36ebaf4$export$e7d0c45026efed5d), 40);
    }
}


function $dd68f4e270ac9ae1$export$2e2bcd8739ae039(CIRCLE_COLORS, isbtw, quasimodoMode) {
    const pinkColor = !quasimodoMode ? CIRCLE_COLORS[1] : 0x000000;
    const colors = [
        CIRCLE_COLORS[0],
        pinkColor,
        CIRCLE_COLORS[2]
    ];
    return isbtw ? [
        colors[1],
        colors[0],
        colors[2]
    ] : colors;
}




var $jISXQ = parcelRequire("jISXQ");
class $215dd4767ceb1a51$export$2e2bcd8739ae039 {
    Game = (0, $75RpY.default).getInstance();
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $e0f5db51c36ebaf4$export$c7609d9da8d80867));
    circle = new (0, $iiVV4.default)(this.cCoord, (0, $e0f5db51c36ebaf4$export$2bf7a7762037fddc), (0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52));
    PointManager = new (0, $0b50a0d0eae351ce$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $b2d727539ee7a1b6$export$2e2bcd8739ae039)(this.cCoord);
    TangentRatioButtonManager = new (0, $8779ca3a487f6ed7$export$2e2bcd8739ae039)();
    AngleManager = new (0, $f3966b3c6cf05d40$export$2e2bcd8739ae039)();
    LineManager = new (0, $10871b41c2a4aae5$export$2e2bcd8739ae039)([
        (0, $e0f5db51c36ebaf4$export$301500ed3a742f63)[1],
        (0, $e0f5db51c36ebaf4$export$7a003cdef7722780)[1]
    ]);
    SliderManager = new (0, $1eea3e1688a0cc7c$export$2e2bcd8739ae039)();
    Quasimodo = new (0, $e6beafb024a9362f$export$2e2bcd8739ae039)(this.cCoord);
    InfoSlider = new (0, $fGH3X.default)((0, $e0f5db51c36ebaf4$export$840ec2322406bfdd));
    genRandomTriangle = new (0, $c558534c0b88c6e9$export$2e2bcd8739ae039)();
    QuasimodoMode = false;
    QuasimodoSwitcherModeCon = new (0, $a2464897f5ac9e36$export$2e2bcd8739ae039)();
    GuideText = new (0, $3DpJv.default)({
        x: 100,
        y: 10
    });
    isbtw;
    GuideTextTangent = new (0, $4db0316fd3255fae$export$2e2bcd8739ae039)();
    CircleAnimationManager = new (0, $5cdef9b8986da9da$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager, this.circle, this.cCoord);
    constructor(){
        this.genRandomTriangle.setVisible(false);
        (0, $1062f3efb6649654$export$f6644f0f2c90144b).on((0, $1062f3efb6649654$export$cb883390c27ec6dd).quasimodoMode, (v)=>this.setQuasimodoMode(v));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.circle.setColors((0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52)));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>{
            this.circle.setColors((0, $dd68f4e270ac9ae1$export$2e2bcd8739ae039)((0, $e0f5db51c36ebaf4$export$9c42f2d310db4e52), this.isbtw, this.QuasimodoMode));
            this.setQuasimodoMode(this.QuasimodoMode);
        });
        this.drawElements();
    }
    setQuasimodoMode(v) {
        this.QuasimodoMode = v;
        [
            this.PointTagManager,
            this.TangentRatioButtonManager
        ].forEach((m)=>m.setAllVisible(!v));
        [
            this.GuideText,
            this.GuideTextTangent
        ].forEach((t)=>t.setVisible(!v));
        this.LineManager.setQuasimodo(v);
        this.Quasimodo.setVisible(v);
        this.AngleManager.setIsShownSecondSegment(v);
        this.drawElements();
    }
    drawElements() {
        const points = this.PointManager.getPoints();
        const radians = this.PointManager.getRadians();
        this.isbtw = (0, $jtirH.default)(points[0], points[3], radians[0], radians[1]);
        const radius = this.PointManager.circleRadius;
        const sltdTPIndex = this.PointManager.getSltdTPointIndex();
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        const tangentCoords = this.PointManager.getTangentCoords();
        const circleDetails = (0, $9557195dc346e5c1$export$e6ec757508d1274)(sltdTPIndex, radians, radius, this.isbtw);
        this.circle.draw(circleDetails);
        this.LineManager.draw(redPointsCoord, tangentCoords, sltdTPIndex);
        this.AngleManager.draw(redPointsCoord, tangentCoords, sltdTPIndex, !this.isbtw);
        if (this.QuasimodoMode) this.Quasimodo.updateCoord(sltdTPIndex, radians, radius, this.isbtw);
        else {
            this.PointTagManager.updateCoord(radians, radius);
            this.TangentRatioButtonManager.draw((0, $hCdov.default)(this.cCoord, radians, radius + 70), sltdTPIndex);
        }
    }
}



const $2f2646907ea6cd9a$var$canvas = document.querySelector("#canvas");
if ($2f2646907ea6cd9a$var$canvas) window.context = new (0, $75RpY.default)($2f2646907ea6cd9a$var$canvas, (0, $e0f5db51c36ebaf4$export$2e51dc0dfab2d766), ()=>new (0, $215dd4767ceb1a51$export$2e2bcd8739ae039)(), (0, $e0f5db51c36ebaf4$export$80701b8f8598becf));
else console.error("Canvas is not found");


//# sourceMappingURL=index.defec7f9.js.map
